import React, { useState, useContext } from 'react';
import { Tooltip } from '@mui/material';
import { withStyles } from '@mui/styles';
import PropTypes from 'prop-types';
import './TooltipFilter.css';
import FilterBox from './FilterBox';
import { TeamAlertsContext } from '../../../../../../context/team-alerts-context';

/* Explanation Props
    - children: node children
    - options: array of objects with the following format
    Format: { title: {string}, isActive: {boolean} }
    Format Details: 
        - title: for option title
        - isActive: to determine if we should filter by the selected option and to be consumed by the checkmark
*/

/**
 * Filter component based on Material UI's Tooltip
 */
const TooltipFilter = ({ children, filterType, isOpen }) => {
    const [tooltipIsOpen, setTooltipIsOpen] = useState(false);
    const { gridFilterOptions, setGridFilterOptions } = useContext(TeamAlertsContext);

    const StyledTooltip = withStyles({
        tooltip: {
            backgroundColor: '#FFF',
            width: '300px',
            height: 'fit-content'
        }
    })(Tooltip);

    const handleApplyFilter = (modifiedOptions, options) => {
        const selectedOptions = [];

        modifiedOptions.forEach(optionsPage => {            
            optionsPage.forEach(option => {
                if (option.isActive === true) {
                    selectedOptions.push(option);
                }
            });
        });

        if (selectedOptions.length) {
            const optionUpdated = { ...options[filterType] };
            optionUpdated.isOptionActive = true;

            setGridFilterOptions({ ...gridFilterOptions, [filterType]: optionUpdated });
        }
        else {
            const optionUpdated = { ...options[filterType] };
            optionUpdated.isOptionActive = false;

            setGridFilterOptions({ ...gridFilterOptions, [filterType]: optionUpdated });
        }
        
        setTooltipIsOpen(false);
    }

    return (
        <div
            className='outer-div tooltip-filter'
            onPointerEnter={isOpen ? () => setTooltipIsOpen(true) : null}
            onPointerLeave={isOpen ? () => setTooltipIsOpen(false) : null}
        >
            <StyledTooltip
                open={tooltipIsOpen}
                interactive="true"
                disableHoverListener
                placement='bottom-start'
                title={
                    <FilterBox
                        handleApplyFilter={handleApplyFilter}
                        filterType={filterType}
                    />
                }
            >
                {children}
            </StyledTooltip>
        </div>
    );
}

TooltipFilter.propTypes = {
    children: PropTypes.node.isRequired,
    filterType: PropTypes.string.isRequired,
    isOpen: PropTypes.bool
}

TooltipFilter.defaultProps = {
    isOpen: true
}

export default TooltipFilter;
